import { Injectable, computed, signal } from '@angular/core';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';

/**
 * Üyelik türü mesajlaşma ayarı (2026-10-22): mesajlaşması açık türler. Değer OrgMetaService.reload'da türlerden
 * (GET /v2/Org/Types, messagingEnabled) yazılır; org oturumu bitince silinir.
 * Bağımlılıksızdır: sol menü (her yüzeyde) org servis zincirini yüklemeden okur; ek HTTP çağrısı yapmaz.
 */
@Injectable({ providedIn: 'root' })
export class OrgMessagingStore {
  /** null = türler henüz okunmadı; menü ve kutucuk bu durumda gizli kalır (bir an görünüp kaybolmaz). Sıralı. */
  private readonly idsSig = signal<readonly string[] | null>(null);
  /** Mesajlaşması açık tür kimlikleri (sıralı); null = henüz okunmadı. */
  readonly enabledTypeIds = this.idsSig.asReadonly();
  /** En az bir türde açık mı; null = bilinmiyor. */
  readonly enabled = computed(() => { const ids = this.idsSig(); return ids === null ? null : ids.length > 0; });
  /** En az bir türde mesajlaşma açık. Türler okunmadıysa false. */
  readonly anyEnabled = computed(() => this.enabled() === true);
  /** Sol menü rxjs akışlarıyla kurulur (mode$ gibi); değer değişince bir kez yayar. */
  private readonly anySubj = new BehaviorSubject<boolean>(false);
  readonly anyEnabled$: Observable<boolean> = this.anySubj.pipe(distinctUntilChanged());

  setFromTypes(types: readonly { id: string; messagingEnabled: boolean }[]): void {
    const ids = types.filter((t) => t.messagingEnabled).map((t) => t.id).sort();
    const prev = this.idsSig();
    // Aynı küme yeniden yazılmaz (bağımlı effect'ler boşuna tetiklenmez).
    if (!prev || prev.length !== ids.length || prev.some((x, i) => x !== ids[i])) this.idsSig.set(ids);
    this.anySubj.next(this.anyEnabled());
  }

  clear(): void { this.idsSig.set(null); this.anySubj.next(false); }
}
